module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h2', {
    staticClass: "h2"
  }, [_c('a', {
    attrs: {
      "id": "page_vii"
    }
  }), _vm._v("PLATES")]), _vm._v(" "), _c('p', {
    staticClass: "line1"
  }), _vm._v(" "), _c('p', {
    staticClass: "tocp"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/06_Dictionary#pla-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("I. Roman sculpture incorporating symbolic "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("motifs")])])]), _vm._v(" "), _c('p', {
    staticClass: "tocp"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/06_Dictionary#pla-2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("II. Modesto Cuixart. Painting, 1958")])]), _vm._v(" "), _c('p', {
    staticClass: "tocp"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/06_Dictionary#pla-3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("III. Portal of the church of San Pablo del Campo, Barcelona")])]), _vm._v(" "), _c('p', {
    staticClass: "tocp"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/06_Dictionary#pla-4",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("IV. Silver chalice, from Ardagh, Co. Longford")])]), _vm._v(" "), _c('p', {
    staticClass: "tocp"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/06_Dictionary#pla-5",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("V. Tenth-century monument at Clonmacnois")])]), _vm._v(" "), _c('p', {
    staticClass: "tocp"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/06_Dictionary#pla-6",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("VI. Chinese version of the cosmic dragon")])]), _vm._v(" "), _c('p', {
    staticClass: "tocp"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/06_Dictionary#pla-7",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("VII. A renaissance relief, from the Doge’s Palace at Venice")])]), _vm._v(" "), _c('p', {
    staticClass: "tocp"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/06_Dictionary#pla-8",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("VIII. Capitals, monastery of Santo Domingo de Silos")])]), _vm._v(" "), _c('p', {
    staticClass: "tocp"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/06_Dictionary#pla-9",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("IX. Early Christian Symbol—thirteenth-century gravestone")])]), _vm._v(" "), _c('p', {
    staticClass: "tocp"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/06_Dictionary#pla-10",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("X. Gothic fountain—Casa del Arcediano, Barcelona")])]), _vm._v(" "), _c('p', {
    staticClass: "tocp"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/06_Dictionary#pla-11",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("XI. Giorgione, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("The Storm")])])]), _vm._v(" "), _c('p', {
    staticClass: "tocp"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/06_Dictionary#pla-12",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("XII. Roman statue of the Twins")])]), _vm._v(" "), _c('p', {
    staticClass: "tocp"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/06_Dictionary#pla-13",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("XIII. Gothic Miniature of The Apparition of the Holy Grail")])]), _vm._v(" "), _c('p', {
    staticClass: "tocp"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/06_Dictionary#pla-14",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("XIV. Bosch, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Garden of Delights")])])]), _vm._v(" "), _c('p', {
    staticClass: "tocp"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/06_Dictionary#pla-15",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("XV. Portel of the Romanesque cathedral at Clonfert, Co. Galway")])]), _vm._v(" "), _c('p', {
    staticClass: "tocp"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/06_Dictionary#pla-16",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("XVI. Chinese symbol of heaven")])]), _vm._v(" "), _c('p', {
    staticClass: "tocp"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/06_Dictionary_02#pla-17",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("XVII. Archetypal image of the Archangel")])]), _vm._v(" "), _c('p', {
    staticClass: "tocpt"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/06_Dictionary_02#pla-18",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("XVIII. Celtic candelabra incorporating symbolic horse and solar wheel")])]), _vm._v(" "), _c('p', {
    staticClass: "tocp"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/06_Dictionary_02#pla-19",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("XIX. Antonio Tapies. A painting, 1958")])]), _vm._v(" "), _c('p', {
    staticClass: "tocp"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/06_Dictionary_02#pla-20",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("XX. Door to the sanctuary of the church of San Plácido, Madrid")])]), _vm._v(" "), _c('p', {
    staticClass: "tocp"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/06_Dictionary_02#pla-21",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("XXI. Libra and other signs of the Zodiac")])]), _vm._v(" "), _c('p', {
    staticClass: "tocp"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/06_Dictionary_02#pla-22",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("XXII. Gothic miniature of ship and whale")])]), _vm._v(" "), _c('p', {
    staticClass: "tocp"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/06_Dictionary_02#pla-23",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("XXIII. ‘Bird-woman’—relief in Barcelona cathedral")])]), _vm._v(" "), _c('p', {
    staticClass: "tocp"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/06_Dictionary_02#pla-24",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("XXIV. Roman painting of twin-tailed siren")])]), _vm._v(" "), _c('p', {
    staticClass: "tocp"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/06_Dictionary_02#pla-25",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("XXV. Greek sphinx, fifth century "), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("B.C")]), _vm._v(".")])]), _vm._v(" "), _c('p', {
    staticClass: "tocp"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/06_Dictionary_02#pla-26",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("XXVI. Jacob’s dream (after an old engraving)")])]), _vm._v(" "), _c('p', {
    staticClass: "tocp"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/06_Dictionary_02#pla-27",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("XXVII. Heraldic supporters—College of San Gregorio, Valladolid")])]), _vm._v(" "), _c('p', {
    staticClass: "tocp"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/06_Dictionary_02#pla-28",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("XXVIII. Tetramorph. Romanesque painting")])]), _vm._v(" "), _c('p', {
    staticClass: "tocp"
  }, [_c('a', {
    attrs: {
      "id": "page_viii"
    }
  }), _c('span', {
    attrs: {
      "href": "#/xhtml/06_Dictionary_02#pla-29",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("XXIX. Roman composition of Adam and Eve")])]), _vm._v(" "), _c('p', {
    staticClass: "tocp"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/06_Dictionary_02#pla-30",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("XXX. The sixth sign of the Zodiac")])]), _vm._v(" "), _c('p', {
    staticClass: "tocp"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/06_Dictionary_02#pla-31",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("XXXI. Detail of a painting by Pedro Berruguete, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("c")]), _vm._v(". 1500")])]), _vm._v(" "), _c('p', {
    staticClass: "tocp"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/06_Dictionary_02#pla-32",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("XXXII. Circular representation of the signs of the Zodiac")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-45b27b8b","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/03_Plates.vue
// module id = 72
// module chunks = 0